import { LegalIssueItem } from './legal-issue-item';

export function getOrderedItemsForSection(
    sectionId: string,
    items: LegalIssueItem[]
): LegalIssueItem[] {
    return items
        .filter((i) => i.sectionId === sectionId)
        .sort((a, b) => a.displayOrder - b.displayOrder);
}
